<script>
  import { onMount } from "svelte"
  import { navigate } from "svelte-routing"
  import Adicionales from "../components/crm/Adicionales.svelte"
  import CicloVenta from "../components/crm/Ciclo_venta.svelte"
  import Comentarios from "../components/crm/Comentarios.svelte"
  import CorreosVerificados from "../components/crm/Correos_verificados.svelte"
  import DatosLaborales from "../components/crm/Datos_laborales.svelte"
  import DireccionVerificada from "../components/crm/Direccion_verificada.svelte"
  import InformacionCliente from "../components/crm/Informacion_cliente.svelte"
  import Probabilidad from "../components/crm/Probabilidad.svelte"
  import TelefonosVerificados from "../components/crm/Telefonos_verificados.svelte"
  import Footer from "../components/Footer.svelte"
  import Header from "../components/Header.svelte"
  import { BASE_URL } from "../stores/BASE_URL"
  import { user } from "../stores/User"
  import getMoneda from "../services/moneda.js"
  import Spinner from "../components/Spinner.svelte"
  import Modal from "../components/Modal.svelte"
  import { verifySession } from "../services/verifySession"
  import Sidebar from "../components/Sidebar.svelte"
  import Container from "../components/Container.svelte"

  export let id
  let isLoading = true
  let errorCarga = ""
  let cliente = {}
  let datos_adicionales = {
    generales: {
      tipo_doc: "",
      documento: "",
      nombres: "",
      sexo: "",
      nacimiento: "",
      nivel_educacion: "",
      est_civil: "",
    },
    telefonos: [],
    correos: [],
    direcciones: [],
    empleos: [],
  }

  let isOpenModalMontos = false
  let isSettingMontos = false
  let montos = {
    monto: 0.0,
    monto_adicional: 0.0,
  }

  let isOpenModalProductos = false
  let isSettingProductos = false
  let productos = []

  let isOpenPeriodo = false
  let isSettingPeriodo = false
  let periodo = {
    year: "",
    month: "",
  }

  // Abreviaturas de meses en español
  const meses = [
    { value: "01", label: "ENE" },
    { value: "02", label: "FEB" },
    { value: "03", label: "MAR" },
    { value: "04", label: "ABR" },
    { value: "05", label: "MAY" },
    { value: "06", label: "JUN" },
    { value: "07", label: "JUL" },
    { value: "08", label: "AGO" },
    { value: "09", label: "SEP" },
    { value: "10", label: "OCT" },
    { value: "11", label: "NOV" },
    { value: "12", label: "DIC" },
  ]

  const getCliente = async () => {
    isLoading = true
    errorCarga = ""
    try {
      const response = await fetch(
        `${BASE_URL}crm.php?ops=getCliente&id=${id}&session_key=${$user.session_key}`,
      )
      const data = await response.json()
      if (data.status === "ok") {
        cliente = data.data
        montos.monto = cliente.monto
        montos.monto_adicional = cliente.monto_adicional

        periodo.month = String(cliente.month).padStart(2, "0")
        periodo.year = String(cliente.year)

        await Promise.all([getDatosAdicionales(), getProductos()])
      } else {
        navigate(`/crm`, { replace: true })
      }
    } catch (error) {
      console.error("Error al cargar el detalle del cliente:", error)
      errorCarga =
        "No se pudo completar la carga del cliente. Intenta nuevamente."
    } finally {
      isLoading = false
    }
  }

  const getDatosAdicionales = async () => {
    const response = await fetch(
      `${BASE_URL}crm.php?ops=getRecursosByDocumento&tipo_doc=${cliente.tipo_doc}&documento=${cliente.documento}&session_key=${$user.session_key}`,
    )
    const data = await response.json()
    if (data.status === "ok") {
      datos_adicionales = data.data
    }
  }

  const updateEtapaClasificacion = async (e) => {
    if (e.detail.etapa == "Cierre") {
      isOpenModalMontos = true
    }

    if (e.detail.clasificacion == "Fidelización") {
      isOpenPeriodo = true
    }

    const response = await fetch(`${BASE_URL}crm.php`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        ops: "updateEtapaClasificacion",
        id: cliente.id,
        etapa: e.detail.etapa,
        clasificacion: e.detail.clasificacion,
        id_etapa: e.detail.id_etapa,
        session_key: $user.session_key,
      }),
    })
    const data = await response.json()
    if (data.status === "ok") {
      cliente.etapa = e.detail.etapa
      cliente.clasificacion = e.detail.clasificacion
    } else {
      alert("Error al actualizar etapa y clasificación: " + data.message)
      getCliente()
    }
  }

  const updateProbabilidad = async (e) => {
    const response = await fetch(`${BASE_URL}crm.php`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        ops: "updateProbabilidad",
        id: cliente.id,
        probabilidad: e.detail.probabilidad,
        session_key: $user.session_key,
      }),
    })
    const data = await response.json()
    if (data.status === "ok") {
      cliente.probabilidad = e.detail.probabilidad
    } else {
      console.error("Error al actualizar probabilidad:", data.message)
    }
  }

  const updateMontos = async () => {
    if (montos.monto === "") {
      montos.monto = 0
    }

    if (montos.monto_adicional === "") {
      montos.monto_adicional = 0
    }

    isSettingMontos = true

    const response = await fetch(`${BASE_URL}crm.php`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        ops: "updateMontos",
        id: cliente.id,
        monto: montos.monto,
        monto_adicional: montos.monto_adicional,
        session_key: $user.session_key,
      }),
    })
    const data = await response.json()
    if (data.status === "ok") {
      isOpenModalMontos = false
      getCliente()
    } else {
      alert("Error al actualizar montos: " + data.message)
    }
    isSettingMontos = false
  }

  const updatePeriodo = async () => {
    if (periodo.year === "" || periodo.month === "") {
      alert("Por favor ingrese un año y mes válidos.")
      return
    }

    isSettingPeriodo = true

    const response = await fetch(`${BASE_URL}crm.php`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        ops: "updatePeriodo",
        id: cliente.id,
        year: periodo.year,
        month: periodo.month,
        session_key: $user.session_key,
      }),
    })
    const data = await response.json()
    if (data.status === "ok") {
      isOpenPeriodo = false
      getCliente()
    } else {
      alert("Error al actualizar periodo: " + data.message)
    }
    isSettingPeriodo = false
  }

  const getPuntos = async () => {
    const response = await fetch(
      `${BASE_URL}session.php?session_key=${$user.session_key}`,
    )
    const resp = await response.json()

    if (resp.status === "success") {
      let temp_user = $user
      temp_user.consumo = resp.data.consumo
      temp_user.consultas = resp.data.consultas
      temp_user.inicio = resp.data.inicio
      temp_user.fin = resp.data.fin
      user.setUser(temp_user)
    } else {
      navigate("/", { replace: true })
    }
  }

  const updateProducto = async () => {
    isSettingProductos = true

    const response = await fetch(`${BASE_URL}crm.php`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        ops: "updateProducto",
        id: cliente.id,
        id_producto: cliente.id_producto,
        session_key: $user.session_key,
      }),
    })
    const data = await response.json()
    if (data.status === "ok") {
      isOpenModalProductos = false
      getCliente()
    } else {
      alert("Error al actualizar producto: " + data.message)
    }
    isSettingProductos = false
  }

  const getProductos = async () => {
    const response = await fetch(
      `${BASE_URL}crm.php?ops=getProductos&session_key=${$user.session_key}`,
    )
    const data = await response.json()
    if (data.status === "ok") {
      const tmp_productos = data.data
      productos = tmp_productos.filter(
        (prod) =>
          prod.id_segmento === cliente.id_segmento && prod.estado === "1",
      )
    } else {
      productos = []
    }
  }

  const calcularEdad = (fecha_nacimiento) => {
    if (!fecha_nacimiento) return null
    const hoy = new Date()
    const nacimiento = new Date(fecha_nacimiento)
    if (!Number.isFinite(nacimiento.getTime())) return null
    let edad = hoy.getFullYear() - nacimiento.getFullYear()
    const mes = hoy.getMonth() - nacimiento.getMonth()
    if (mes < 0 || (mes === 0 && hoy.getDate() < nacimiento.getDate())) {
      edad--
    }
    return edad >= 0 && edad <= 130 ? edad : null
  }

  $: edadCliente = calcularEdad(datos_adicionales.generales?.nacimiento)
  $: nivelEducacion = String(
    datos_adicionales.generales?.nivel_educacion ?? "",
  ).trim()

  getCliente()

  onMount(() => {
    if (!$user) {
      navigate("/", { replace: true })
    } else {
      verifySession($user.session_key)
      getPuntos()
      if (!$user.permisos.includes("crm")) {
        user.setUser(null)
        navigate("/", { replace: true })
      }

      //Pass
      if ($user.actualizar_clave == "1") {
        navigate("/seguridad", { replace: true })
      }

      //C
      if ($user.verificar == "1") {
        navigate("/verificar", { replace: true })
      }
    }
  })
</script>

{#if $user}
  <main class="d-flex flex-column md:flex-row page-shell">
    <Sidebar />
    <div class="d-flex flex-column flex-grow-1 page-content">
      <Header />

      <div class="container-fluid bg-2 flex-grow-1 pt-3 pb-5 h-100">
        {#if isLoading}
          <Spinner />
        {:else if errorCarga}
          <div class="alert theme-danger" role="alert">
            {errorCarga}
            <button
              type="button"
              class="btn btn-sm btn-outline theme-danger ms-3"
              on:click={getCliente}>Reintentar</button
            >
          </div>
        {:else}
          <div class="row g-3">
            <div class="col-12">
              <button
                class="btn btn-text theme-primary btn-sm px-0"
                on:click={() => navigate("/crm", { replace: true })}
              >
                <i class="bi bi-chevron-left"></i> Volver a clientes
              </button>
            </div>
            <div class="col-12 lg:col-6 xl:col-8 2xl:col-9">
              <h6 class="mb-0 fs-md">
                {cliente.nombres}
              </h6>
              <p class="small fg-3 d-flex flex-wrap align-items-center gap-1">
                <span class="me-3">Documento: {cliente.documento}</span>
                {#if edadCliente !== null}
                  <span class="badge theme-secondary">{edadCliente} años</span>
                {/if}
                {#if nivelEducacion}
                  <span class="badge theme-success">{nivelEducacion}</span>
                {/if}
              </p>
            </div>
            <div class="col-12 lg:col-6 xl:col-4 2xl:col-3">
              <Probabilidad {cliente} on:update={updateProbabilidad} />
            </div>
            <div class="col-12 text-center">
              <Container>
                <h6 class="text-start">
                  <i class="bi-diagram-3 fg-secondary me-3"></i> Etapa comercial
                </h6>
                <CicloVenta {cliente} on:update={updateEtapaClasificacion} />
              </Container>
            </div>
            <div class="col-12">
              <Container>
                <h6>
                  <i class="bi-briefcase fg-secondary me-3"></i> Resumen comercial
                </h6>
                <div class="row gy-3 gx-12">
                  <div class="col-auto">
                    <p class="mb-0 small">
                      <span class="fg-secondary">Segmento: </span>
                    </p>
                    <p class="mb-0 small">
                      {cliente.segmento}
                    </p>
                  </div>
                  <div class="col-auto">
                    <p class="mb-0 small">
                      <span class="fg-secondary">Producto: </span>
                    </p>
                    <p class="mb-0 small">
                      {cliente.producto}
                      <button
                        class="btn btn-sm fg-primary"
                        on:click={() => (isOpenModalProductos = true)}
                        ><i class="bi bi-pencil-square"></i></button
                      >
                    </p>
                  </div>
                  <div class="col-auto">
                    <p class="mb-0 small">
                      <span class="fg-secondary">Periodo: </span>
                    </p>
                    <p class="mb-1 small">
                      {#if cliente.year != ""}
                        {cliente.year}-{cliente.month}
                      {/if}
                      <button
                        class="btn btn-sm fg-primary"
                        on:click={() => (isOpenPeriodo = true)}
                        ><i class="bi bi-pencil-square"></i></button
                      >
                    </p>
                  </div>
                  <div class="col-auto">
                    <p class="mb-0 small">
                      <span class="fg-secondary">Monto factura: </span>
                    </p>
                    <p class="mb-0 small">
                      {getMoneda(cliente.monto)}
                      <button
                        class="btn btn-sm fg-primary"
                        on:click={() => (isOpenModalMontos = true)}
                        ><i class="bi bi-pencil-square"></i></button
                      >
                    </p>
                  </div>
                  <div class="col-auto">
                    <p class="mb-0 small">
                      <span class="fg-secondary">Monto adicional: </span>
                    </p>
                    <p class="mb-0 small">
                      {getMoneda(cliente.monto_adicional)}
                      <button
                        class="btn btn-sm fg-primary"
                        on:click={() => (isOpenModalMontos = true)}
                        ><i class="bi bi-pencil-square"></i></button
                      >
                    </p>
                  </div>
                </div>
              </Container>
            </div>

            <div class="col-12 lg:col-6 2xl:col-4">
              <InformacionCliente
                {cliente}
                {datos_adicionales}
                {calcularEdad}
              />
              <div class="mb-3"></div>
              <DireccionVerificada {cliente} on:update={getCliente} />
            </div>

            <div class="col-12 lg:col-6 2xl:col-3">
              <TelefonosVerificados {cliente} on:update={getCliente} />
              <div class="mb-3"></div>
              <CorreosVerificados {cliente} on:update={getCliente} />
              <div class="mb-3"></div>
              <DatosLaborales {cliente} on:update={getCliente} />
            </div>

            <div class="col-12 lg:col-6 2xl:col-5">
              <Comentarios {cliente} />
            </div>

            <div class="col-12">
              <Adicionales
                {cliente}
                {datos_adicionales}
                on:update={getCliente}
              />
            </div>
          </div>
          <Modal
            isOpen={isOpenModalMontos}
            on:close={() => (isOpenModalMontos = false)}
            title="Monto factura y monto adicional"
          >
            <div class="mb-3">
              <label for="monto" class="form-label">Monto factura</label>
              <input
                type="number"
                id="monto"
                class="form-control form-control-sm"
                bind:value={montos.monto}
                placeholder="Ingrese el monto de la factura"
              />
            </div>
            <div class="mb-3">
              <label for="monto_adicional" class="form-label"
                >Monto adicional</label
              >
              <input
                type="number"
                id="monto_adicional"
                class="form-control form-control-sm"
                bind:value={montos.monto_adicional}
                placeholder="Ingrese el monto adicional"
              />
            </div>
            <div class="mb-3 text-end">
              {#if isSettingMontos}
                <button
                  class="btn btn-solid theme-primary btn-sm disabled"
                  disabled>Guardando...</button
                >
              {:else}
                <button
                  class="btn btn-solid theme-primary btn-sm"
                  on:click={updateMontos}>Guardar</button
                >
              {/if}
            </div>
          </Modal>

          <Modal
            isOpen={isOpenPeriodo}
            on:close={() => (isOpenPeriodo = false)}
            title="Actualizar periodo"
          >
            <div class="mb-3">
              <label for="year" class="form-label">Año</label>

              <select
                id="year"
                class="form-control form-control-sm"
                bind:value={periodo.year}
                on:change={() => {
                  periodo.month = ""
                }}
              >
                <option value="">Seleccionar año</option>
                {#each Array(new Date().getFullYear() - 2024)
                  .fill(0)
                  .map((_, i) => 2025 + i) as year}
                  <option value={String(year)}>{year}</option>
                {/each}
              </select>
            </div>
            <div class="mb-3">
              <label for="month" class="form-label">Mes</label>
              <select
                id="month"
                class="form-control form-control-sm"
                bind:value={periodo.month}
              >
                <option value="">Seleccionar mes</option>
                {#if periodo.year != ""}
                  {#each meses as mes}
                    <option
                      value={mes.value}
                      disabled={periodo.year === "2025" &&
                        Number(mes.value) < 6}
                    >
                      {mes.label}
                    </option>
                  {/each}
                {/if}
              </select>
            </div>
            <div class="mb-3 text-end">
              {#if isSettingPeriodo}
                <button
                  class="btn btn-solid theme-primary btn-sm disabled"
                  disabled>Guardando...</button
                >
              {:else}
                <button
                  class="btn btn-solid theme-primary btn-sm"
                  on:click={updatePeriodo}>Guardar</button
                >
              {/if}
            </div>
          </Modal>

          <Modal
            isOpen={isOpenModalProductos}
            on:close={() => (isOpenModalProductos = false)}
            title="Actualizar producto"
          >
            <div class="mb-3">
              <label for="producto" class="form-label">Producto</label>
              <select
                id="producto"
                class="form-control form-control-sm"
                bind:value={cliente.id_producto}
              >
                <option value={1}>SIN PRODUCTO</option>
                {#each productos as p}
                  <option value={p.id}>{p.nombre}</option>
                {/each}
              </select>
            </div>
            <div class="mb-3 text-end">
              {#if isSettingProductos}
                <button
                  class="btn btn-solid theme-primary btn-sm disabled"
                  disabled>Guardando...</button
                >
              {:else}
                <button
                  class="btn btn-solid theme-primary btn-sm"
                  on:click={updateProducto}>Guardar</button
                >
              {/if}
            </div>
          </Modal>
        {/if}

        <Footer />
      </div>
    </div>
  </main>
{/if}

<style>
  .page-shell {
    height: 100vh;
    height: 100dvh;
    overflow: hidden;
  }

  .page-content {
    min-width: 0;
    min-height: 0;
    overflow-y: auto;
    overflow-x: hidden;
  }

  @media (max-width: 767.98px) {
    .page-shell {
      height: auto;
      min-height: 100vh;
      overflow: visible;
    }

    .page-content {
      overflow: visible;
    }
  }
</style>
